"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackLinkClick = exports.trackBannerShow = void 0;
var _analytics = require("@cian/analytics");
const trackLinkClick = () => {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'newbuilding_banner',
    action: 'click_sopr',
    label: 'reorientation_rent'
  });
};
exports.trackLinkClick = trackLinkClick;
const trackBannerShow = () => {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'newbuilding_banner',
    action: 'show_sopr',
    label: 'reorientation_rent'
  });
};
exports.trackBannerShow = trackBannerShow;